import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../utility/api';
import BookView from '../components/BookComponents/BookView';
import { toast } from 'react-toastify';

const BookPage = () => {
    const { id } = useParams();
    const [book, setBook] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchBookDetails();
    }, [id]);

    const fetchBookDetails = async () => {
        try {
            setLoading(true);
            const response = await api.get(`/books/${id}`);
            setBook(response.data);
        } catch (error) {
            toast.error('Failed to fetch book details');
            console.error('Error fetching book:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <p>Loading...</p>;
    }

    if (!book) {
        return (
            <div className="container g-pt-70 g-pb-30">
                <div className="text-center">
                    <h3>Book not found</h3>
                    <p>The book you're looking for doesn't exist.</p>
                </div>
            </div>
        );
    }

    return <BookView book={book} />;
};

export default BookPage; 